import type { SelectCharactersAction } from "../types/action";
import type { HorrorRaceState } from "../types/game-state";
import { createFewPlayerAdditions } from "../utils/coin-pool";

export function applySelectCharacters(
  state: HorrorRaceState,
  action: SelectCharactersAction,
): HorrorRaceState {
  const updatedPlayers = state.players.map((player) => {
    if (player.id !== action.playerId) {
      return player;
    }
    const remainingHand = player.hand.filter(
      (c) => !action.characters.includes(c),
    );
    return {
      ...player,
      secretSelection: action.characters,
      hand: remainingHand,
    };
  });

  const currentPlayer = state.players.find((p) => p.id === action.playerId);
  const returnedCoins = currentPlayer
    ? currentPlayer.hand.filter((c) => !action.characters.includes(c))
    : [];

  const newSelectionsComplete = state.selectionsComplete + 1;
  const allSelected = newSelectionsComplete === state.config.playerCount;

  // When the last player selects, ≤5-player games top up the pool with the
  // few-player additions (official). The store shuffles before the first draw.
  const additions = allSelected
    ? createFewPlayerAdditions(state.config.playerCount)
    : [];

  return {
    ...state,
    players: updatedPlayers,
    coinPool: [...state.coinPool, ...returnedCoins, ...additions],
    selectionsComplete: newSelectionsComplete,
    phase: allSelected ? "ROUND_DRAW_AND_PLACE" : state.phase,
  };
}
